var map = {
	"./icon_footer_basketball.png": "fb5e",
	"./icon_footer_close.png": "e83a",
	"./icon_footer_event_selected.png": "7a1b",
	"./icon_footer_event_unselect.png": "9a98",
	"./icon_footer_fantacy_1_selected.png": "dcb7",
	"./icon_footer_fantacy_1_unselect.png": "ee5e",
	"./icon_footer_fantasy_selected.png": "1178",
	"./icon_footer_fantasy_unselect.png": "ee9b",
	"./icon_footer_fav_selected.png": "cc7f",
	"./icon_footer_fav_unselect.png": "7ca9",
	"./icon_footer_fifa.png": "0750",
	"./icon_footer_fifa_selected.png": "f659",
	"./icon_footer_fifa_unselect.png": "f787",
	"./icon_footer_football.png": "0036",
	"./icon_footer_highlights_selected.png": "ffe1",
	"./icon_footer_highlights_unselect.png": "bcf1",
	"./icon_footer_hkfs_selected.png": "3ae5",
	"./icon_footer_hkfs_unselect.png": "5478",
	"./icon_footer_home_selected.png": "c19e",
	"./icon_footer_home_unselect.png": "2c74",
	"./icon_footer_more_unselect.png": "4a21",
	"./icon_footer_news_selected.png": "59a6",
	"./icon_footer_news_unselect.png": "ffd3",
	"./icon_footer_notification_unselect.png": "ce52",
	"./icon_footer_refresh.png": "67ea",
	"./icon_footer_sport_basketball_selected.png": "4c91",
	"./icon_footer_sport_football_selected.png": "803e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0fb";